import React, { useState, useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import $ from 'jquery'
import { getNumbertOfMembersApi, getNumbertOfLeadsGeneratedApi, getLeadsStatusApi, getCommunityDashboardData, getCommunityPersonalApi,getDashboardTreeApi } from '../Community/CommunityActionCreator'
import ImageOne from '../Community/Images/directleadicon.png'
import ImageTwo from '../Community/Images/totalleadicon.png'
import ImageThree from '../Community/Images/Earnings.png'
import ImageFour from '../Community/Images/communityicon.png'
import UserIamge from '../Community/Images/userimage.png'
// import ClockImage from '../Images/ic_twotone-watch-later.png'
import GrowthIcon from '../Community/Images/Growth (2).png'
import ReferIcon from '../Community/Images/Group 5694 (1).png'
import TopMember from '../Community/Images/Group 5695.png'
import PendingIcon from '../Community/Images/Group 5696.png'
import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer,
    BarChart,
    Bar
} from "recharts";
import { Slider } from '@mui/material'
import { Link } from "react-router-dom";
// import Routes from '../../../../Layout/Routes'
import NoDataImage from '../Community/Images/imagenotdata.jpg'

let data = {

    "directCommunityMember": 1000,
    "completeLagCommunityMember": 1000,
    "monthVsAmtDisbursed": {},
    "monthVsAmtDisbursedDirectly": {},
    "totalCommissionValueDirectly": 0,
    "totalCommissionValue": 1000000,
    "name": "Deepanshu deep",
    "levelName": "Bronze",
    "profileLink": "https://backend.credhub.in/downloadFile?downloadfile=img/k8GVK1S3oBWgeUlq1wVjUWESFneZxsF9/02-11-2022/Group&type=img",
    "nextStageTargetPercentage": 80,
    "totalInCompleteProfiles": 800,
    "totalInCompleteLeads": null,
    "topCommunityMemberName": null,
    "topCommunityTotalLeadsAdded": null
}

const CommunityDetailDashboard = ({handlePage,communityId}) => {
    const [NumberOfMembers, setNumberOfMembers] = useState('')
    const [NumberOfLeadsGenerated, setNumberOfGeneratedLeads] = useState('')

    const [leadStatus, setLeadStatus] = useState({})
    const [loaderState, setLoaderState] = useState(false)
    const [graphType, setData] = useState('monthly')
    const [graphData, setDashBoardData] = useState()
    const [progressValue, setProgressValue] = useState(0)
    const [graphDataFromApi, setgraphDataFromApi] = useState()
    const [toAchieve, setToAchieve] = useState([])
    const [qrData, setQrData] = useState()
    const location = useLocation();

    const marks = [

        {
            value: 20,
            label: '',
        },
        {
            value: 40,
            label: '',
        },

        {
            value: 60,
            label: '',

        },
        {
            value: 80,
            label: '',
        },
        {
            value: 100,
            label: graphData && graphData.levelName ? graphData.levelName : '',
        },
    ];

    useEffect(() => {
        if(communityId){
            getNumbertOfLeadsGenerated(communityId)
            getLeadsStatus(communityId)
            getNumbertOfMembers(communityId)
            console.log(communityId)
            getTreeData(communityId)
            // makeTreeHandler(treeData)
            // getCommunityDashboardDataApi('ozT32Zcr9KXxhp8EIVr03PBNEtzXbdil')
            getCommunityDashboardDataApi(communityId)
            getPersonalDetail(communityId)
        }else{
        getTreeData(window.sessionStorage.getItem('communityId'))
        // makeTreeHandler(treeData)
        // getCommunityDashboardDataApi('ozT32Zcr9KXxhp8EIVr03PBNEtzXbdil')
        getCommunityDashboardDataApi(window.sessionStorage.getItem('communityId'))
        getPersonalDetail(window.sessionStorage.getItem('communityId'))
        }

    }, [])
    const getPersonalDetail = (data) => {
        getCommunityPersonalApi(data,
            callBack => {
                if (callBack !== null) {
                    setQrData(callBack)

                }
            }, error => {

            })
    }
    const makeGraphDta = (To) => {
        let data = []

        Object.entries(To).map((hh, ll) => {
            console.log(hh[0], 'hh')

            data.push({
                name: hh[0],
                uv: '',
                Amount: hh[1],
                amt: hh[1],
            })

        })
        // console.log(data.reverse())

        setgraphDataFromApi(data.reverse())

        console.log(graphDataFromApi, 'graphDataFromApi')


    }

    const getCommunityDashboardDataApi = (communityId) => {
        getCommunityDashboardData(communityId, graphType, callBack => {
            console.log(callBack.data.levelName)
            let makeAchievedata = []

            makeAchievedata = [{
                value: 0,
                label: '',
            },
            {
                value: '',
                label: '',
            },
            {
                value: '',
                label: '',
            },
            {
                value: '',
                label: '',
            },
            {
                value: '',
                label: '',
            },
            {
                value: 100,
                label: callBack.data.levelName === 'Bronze' ? 'Silver' : callBack.data.levelName === 'Silver' ? 'Gold' : callBack.data.levelName === 'Gold' ? 'Platinum' : callBack.data.levelName === 'Platinum' ? 'Diamond' : '',
            }]
            setToAchieve(makeAchievedata)
            setDashBoardData(callBack.data)
            // setDashBoardData(data)
            if (callBack && callBack.data.monthVsAmtDisbursed) {
                makeGraphDta(callBack.data.monthVsAmtDisbursed)
            }
            if (callBack.data.levelName === 'Bronze') {
                setProgressValue(20)
            }
            if (callBack.data.levelName === 'Silver') {
                setProgressValue(40)
            }
            if (callBack.data.levelName === 'Gold') {
                setProgressValue(60)
            }

            if (callBack.data.levelName === 'Platinum') {
                setProgressValue(80)
            }
            if (callBack.data.levelName === 'Diamond') {
                setProgressValue(100)
            }

        })
    }
    const getTreeData = (id) => {
        getDashboardTreeApi(id, callBack => {
            makeTreeHandler(callBack)
            // makeTreeHandler(newData)

        }, error => {

        })
    }


    const getNumbertOfMembers = (data) => {
        setLoaderState(true)
        getNumbertOfMembersApi(data,
            callBack => {
                if (callBack !== null) {
                    setNumberOfMembers(callBack.data)
                    setLoaderState(false)
                }
            }, error => {
                setLoaderState(false)

            })
    }
    const getNumbertOfLeadsGenerated = (data) => {
        setLoaderState(true)
        getNumbertOfLeadsGeneratedApi(data,
            callBack => {
                if (callBack !== null) {
                    setNumberOfGeneratedLeads(callBack.data)
                    setLoaderState(false)
                }
            }, error => {
                setLoaderState(false)

            })
    }
    const getLeadsStatus = (data) => {
        setLoaderState(true)
        getLeadsStatusApi(data,
            callBack => {
                if (callBack !== null) {
                    setLeadStatus(callBack.data)
                    setLoaderState(false)
                }
            }, error => {
                setLoaderState(false)

            })
    }

    const makeTreeHandler = (members) => {
        (members.map((data, i) => {
            console.log(data.communityDetailDO)
        }))
        var testImgSrc = "http://0.gravatar.com/avatar/06005cd2700c136d09e71838645d36ff?s=69&d=wavatar";
        (function heya(parentCommunityId) {
            // This is slow and iterates over each object everytime.
            // Removing each item from the array before re-iterating 
            // may be faster for large datasets.
            for (var i = 0; i < members.length; i++) {
                var member = members[i];
                if (member.parentCommunityId === parentCommunityId) {
                    var parent = parentCommunityId ? $("#containerFor" + parentCommunityId) : $("#mainTreeContainer"),
                        communityId = member.communityId,
                        communityName = (member.communityDetailDO.name).split(' ')[0] !== 'CA' && (member.communityDetailDO.name).split(' ')[0] !== 'CS' ? (member.communityDetailDO.name).split(' ')[0] : (member.communityDetailDO.name).split(' ')[1],
                        // metaInfo = "<div " + testImgSrc + "'/>" + member.otherInfo + " ($" + member.amount + ")";
                        metaInfo = "<div " + "'/>" + 'Name :  ' + member.communityDetailDO.name + '<br></br>' + 'Mobile Number:  ' + member.communityDetailDO.mobileNo + "";

                    parent.append("<div class='tree-container' id='containerFor" + communityId + "'><div class='member'>" + communityName + "<div class='metaInfo'>" + metaInfo + "</div></div></div>");
                    // parent.append("<div class='tree-container' id='containerFor" + communityId + "'><div class='member'>" + communityName + "</div></div>");
                    heya(communityId);
                }
            }
        }(null));

        var pretty = function () {
            var self = $(this),
                children = self.children(".tree-container"),
                width = (100 / children.length) - 1;
            children
                .css("width", width + "%")
                .each(pretty);

        };
        $("#mainTreeContainer").each(pretty);
    }

    const handlePagechange =()=>{
        handlePage("","addcommunityLeadMain")
    }



    return (
        <div className='container-fluid main-dash-scroll'>
            <div className='row' >
                <div className='col-sm-3 col-xs-12'>
                    <div className='dashboard-first-card first-card-dash'>
                        DIRECT LEADS
                        <br />
                        <b className=''> {graphData ? graphData.totalDirectLeads : ""}</b>
                        <div className='dashboard-icons-div' style={{ background: '#FF6A92' }}>
                            <img src={ImageOne} />
                        </div>
                    </div>
                </div>
                <div className='col-sm-3 col-xs-12'>
                    <div className='dashboard-first-card second-card-dash'>
                        DIRECT MEMBER
                        <br />
                        <b className=''> {graphData ? graphData.directCommunityMember : ""}</b>
                        <div className='dashboard-icons-div' style={{ background: '#267DFF' }}>
                            <img src={ImageTwo} />
                        </div>
                    </div>
                </div>
                <div className='col-sm-3 col-xs-12'>
                    <div className='dashboard-first-card third-card-dash'>
                        MY EARNING
                        <br />
                        <b className=''>{graphData ? graphData.totalCommissionValueDirectly : ""}</b>
                        <div className='dashboard-icons-div' style={{ background: '#FFB828' }}>
                            <img src={ImageThree} />
                        </div>
                    </div>
                </div>
                <div className='col-sm-3 col-xs-12'>
                    <div className='dashboard-first-card fourth-card-dash'>COMMUNITY EARNINGS
                        <br />
                        <b className=''>{graphData ? graphData.totalCommissionValue : ""}</b>
                        <div className='dashboard-icons-div' style={{ background: '#54CBA1' }}>
                            <img src={ImageFour} />
                        </div>
                    </div>

                </div>

            </div>
            <div className='row'>
                <div className='col-sm-7 col-xs-12'>
                    <div className='chart-div-dashboard'>
                        <h4 className='text-color ml-2'><b style={{ fontWeight: '900' }}>Growth </b> <img width='16px' src={GrowthIcon} /></h4>
                        {graphDataFromApi ?
                            //      <ResponsiveContainer width="100%" height="100%">
                            //                  <BarChart width={900} height={400} data={graphDataFromApi}
                            //                  margin={{
                            //                             top: 20,
                            //                             right: 30,
                            //                             left: 20,
                            //                             bottom: 5
                            //                         }}
                            //                  >
                            //                          <XAxis dataKey="name" />
                            //                          <YAxis />
                            //                          <Tooltip />
                            //                          <CartesianGrid strokeDasharray="3 3" />
                            //   <XAxis dataKey="name" />
                            //   <YAxis />
                            //   <Tooltip />
                            //   <Legend />
                            //   <Bar dataKey="Amount" fill="#8884d8" />
                            //   <Bar dataKey="uv" fill="#82ca9d" />
                            //                </BarChart>
                            //    </ResponsiveContainer>
                            <LineChart

                                width={720}
                                height={300}
                                data={graphDataFromApi}
                                margin={{
                                    top: 20,
                                    right: 30,
                                    left: 20,
                                    bottom: 20
                                }}
                            >
                                <CartesianGrid strokeDasharray="1 1" />
                                <XAxis dataKey="name" />
                                <YAxis />
                                <Tooltip />

                                {/* <Legend align='left' /> */}
                                <Line
                                    type="monotone"
                                    dataKey="Amount"
                                    stroke="#267DFF"
                                    activeDot={{ r: 10 }}
                                    strokeWidth={5}
                                />
                            </LineChart>
                            : <div className='text-center'> <img src={NoDataImage} style={{ width: '50%' }} alt='' image /></div>}
                    </div>

                </div>
                <div className='col-sm-5 col-xs-12'>
                    <div className='profile-dashboard-card ' style={{ overflow: 'auto' }}>
                        <div className='row mt-1'>
                            <div className='col-sm-5 col-xs-12'>
                                <div className='profile-image-outline'
                                > <img src={graphData && graphData.profileLink ? graphData.profileLink : UserIamge} style={{ width: '130px', height: '130px', marginLeft: '9px', marginTop: '10px' }} />
                                </div>
                            </div>
                            <div className='col-sm-7 col-xs-12'>
                                <h3 className='text-color mt-5'><strong>{graphData ? graphData.name : ""}</strong></h3>
                                <h6 className=' mt-2' style={{ color: '#FFB828' }}>{graphData ? graphData.levelName : ""}</h6>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-sm-4 col-xs-12 text-center'>
                                <p className='ptag-text mt-2'>Earning</p>
                                <h3><b>-</b></h3>
                            </div>
                            <div className='col-sm-4 col-xs-12 text-center'>
                                <p className='ptag-text mt-2'>Total Leads</p>
                                <h3><b>-</b></h3>

                            </div>
                            <div className='col-sm-4 col-xs-12 text-center'>
                                <p className='ptag-text mt-2'>Total Members</p>
                                <h3><b>-</b></h3>

                            </div>

                        </div>


                        {/* <div className='text-center mt-1'>
                            <div onClick={()=>handlePagechange()}>
                                <button className='add-btn-lead' style={{ padding: '10px', float: 'none' }} >
                                    <i className="fa fa-plus-circle"></i>&nbsp;&nbsp;Add
                                </button>
                                
                            </div>
                        </div> */}
                    </div>

                </div>

            </div>
            {graphData ?
                <div className='row'>
                    <div className='col-sm-2 col-xs-12'>
                        <div className='last-section-dashboard ' style={{height:'263px'}}>
                            <h4 className='text-color ml-2'><b style={{ fontWeight: '900' }}>Refer </b> <img width='16px' src={ReferIcon} /></h4>
                            {qrData ?
                                <div className='text-center'>
                                    <img src={qrData.qrCodeUrl} className='' style={{ width: '86%' }} />
                                </div>
                                : ""}
                        </div>
                    </div>
                    <div className='col-sm-2 col-xs-12'>
                        <div className='last-section-dashboard ' style={{height:'263px'}}>
                            <h4 className='text-color ml-2'><b style={{ fontWeight: '900' }}>Top Member </b> <img width='16px' src={TopMember} /></h4>

                            <h5 className='text-color ml-2' ><b>{graphData.topCommunityMemberName}</b></h5>
                            <br />
                            <h5 className='text-color ml-2' ><b>{graphData.topCommunityTotalLeadsAdded}</b></h5>

                        </div>
                    </div>
                    <div className='col-sm-3 col-xs-12'>
                        <div className='last-section-dashboard ' style={{height:'263px'}}>
                            <h4 className='text-color ml-2'><b style={{ fontWeight: '900' }}>Pending </b> <img width='16px' src={PendingIcon} /></h4>
                            <div className='row'>
                                <div className='col-sm-8 col-xs-12'>
                                    <p className='ptag-text ml-2'>Community Profile</p>
                                </div>
                                <div className='col-sm-4 col-xs-12'>
                                    <p className='text-color text-right'><h3><b>{graphData.totalInCompleteProfiles}</b></h3></p>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-sm-8 col-xs-12'>
                                    <p className='ptag-text ml-2'>Leads</p>
                                </div>
                                <div className='col-sm-4 col-xs-12'>
                                    <p className='text-color text-right'><h3><b>{graphData.totalInCompleteLeads}</b></h3></p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='col-sm-5 col-xs-12'>

                        <div className='progress-dashboard'>
                            <h4 className='text-color ml-2'><b style={{ fontWeight: '900', marginLeft: '-10px' }}>Goal </b></h4>


                            <div className='currentprogress'>

                                <h6 className='text-color '><strong>Current Progress</strong></h6>
                                <Slider
                                    min={20}
                                    max={100}
                                    disabled
                                    step={20}
                                    valueLabelDisplay="auto"
                                    value={progressValue}
                                    size="large"
                                    marks={marks}

                                />
                            </div>
                            <h6 className='text-color '><strong>To Achieve</strong></h6>
                            <Slider
                                min={0}
                                max={100}
                                disabled
                                step={10}
                                valueLabelDisplay="auto"
                                value={graphData && graphData.nextStageTargetPercentage ? graphData.nextStageTargetPercentage * 100 : ''}
                                size="large"
                                marks={toAchieve}

                            />
                        </div>


                    </div>
                    {/* <div className='col-sm-4 col-xs-12'>
                            <div className='leads-box leads-box1'>
                                <h3> Pending<br /> Leads</h3>
                                <img src={ClockImage} />
                                <h3 className='mt-4'>{graphData ? graphData.totalInCompleteLeads : ""}</h3>
                                {graphData && graphData.totalInCompleteLeads ? <Link to={{
                                    pathname: Routes.COMMUNITY_ALL_LEADS,
                                }} > <button><i className='fa fa-arrow-right'></i></button> </Link> : ""}
                            </div>
                        </div> */}
                </div>
                : ""}

            {/* <div>
            <div className='row'>
                <div className='row'>
                    <div className='col-sm-5 col-xs-12'>
                        Number Of Members Added :

                    </div>
                    <div className='col-sm-1 col-xs-12 text-center' style={{ fontSize: '16px', backgroundColor: 'lightgray', borderRadius: '5px' }}>
                        <b >{NumberOfMembers && NumberOfMembers.noOfMembersAdded && NumberOfMembers.noOfMembersAdded !== undefined ? NumberOfMembers.noOfMembersAdded : ""}</b>
                    </div>
                    <div className='col-sm-5 col-xs-12'>
                        Number Of Leads Generated :
                    </div>
                    <div className='col-sm-1 col-xs-12 text-center' style={{ fontSize: '16px', backgroundColor: 'lightgray', borderRadius: '5px' }}>
                        <b >{NumberOfLeadsGenerated && NumberOfLeadsGenerated.leadsGeneratedByMember && NumberOfLeadsGenerated.leadsGeneratedByMember !== undefined ? NumberOfLeadsGenerated.leadsGeneratedByMember : ""}</b>
                    </div>

                </div>

            </div>
            <div className='row'>
                {leadStatus && leadStatus !== undefined && leadStatus !== '' ? Object.entries(leadStatus).map((data, i) => {
                    return (
                        <div className='col-sm-3 col-xs-12' >
                            <div className='card-dashboard' >
                                <div className='icon' style={{ background: data[0] === 'Approved' ? '#fcf0dd' : data[0] === 'New Lead' ? '#e0ebfd' : data[0] === 'Disbursed' ? '#e0f4ec' : data[0] === 'Paid' ? '#fceef3' : "", color: '#000', fontSize: '20px' }}>
                                    <i class="fa fa-line-chart" aria-hidden="true"></i>

                                </div>
                                <div className='heading-dashboard'>
                                    <h6> {data[0]}</h6>
                                    <h6 className='text-right' style={{ color: '#000' }}><b>{data[1]}</b></h6>
                                </div>

                            </div>
                        </div>
                    )
                }) : ""}
                <div className='col-xs-12 clearfix' id="mainTreeContainer"></div>
            </div>
        </div>  */}
        </div>
    )
}

export default CommunityDetailDashboard;